<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
    :modal-append-to-body="false"
    :append-to-body="true"
    class="session-message-dialog">
    
    <!-- 会话信息 -->
    <div class="session-info" v-if="sessionData">
      <el-row :gutter="20">
        <el-col :span="8">
          <div class="info-item">
            <label>会话ID：</label>
            <span>{{ sessionData.sessionId }}</span>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="info-item">
            <label>会话标题：</label>
            <span>{{ sessionData.title || '无标题' }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    
    <!-- 消息列表 -->
    <div class="message-list">
      <avue-crud 
        :option="messageOption"
        :table-loading="loading"
        :data="messageData"
        :page="page"
        ref="messageCrud"
        @current-change="currentChange"
        @size-change="sizeChange"
        @refresh-change="refreshChange"
        @on-load="onLoad">
        
        <template slot="menu" slot-scope="scope">
          <el-button 
            type="text"
            size="small"
            icon="el-icon-s-order"
            @click="handleViewTasks(scope.row)">
            查看任务
          </el-button>
        </template>
        
        <!-- 消息类型显示 -->
        <template slot="msgType" slot-scope="scope">
          <el-tag 
            :type="getMsgTypeColor(scope.row.msgType)"
            size="small">
            {{ getMsgTypeText(scope.row.msgType) }}
          </el-tag>
        </template>
        
        
        <!-- 消息内容显示 -->
        <template slot="content" slot-scope="scope">
          <div class="message-content">
            <el-tooltip 
              :content="scope.row.content"
              placement="top"
              :disabled="!scope.row.content || scope.row.content.length <= 50">
              <span>{{ truncateText(scope.row.content, 50) }}</span>
            </el-tooltip>
          </div>
        </template>
      </avue-crud>
    </div>
    
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getAiSessionMsgList } from "@/api/aiSession";

export default {
  name: 'SessionMessageDialog',
  
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    sessionData: {
      type: Object,
      default: () => null
    }
  },
  
  data() {
    return {
      loading: false,
      messageData: [],
      page: {
        size: 10,
        current: 1,
        total: 0
      },
      messageOption: {
        height: 400,
        tip: false,
        border: true,
        index: true,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        selection: false,
        dialogClickModal: false,
        labelWidth: 100,
        column: [
          {
            label: "消息ID",
            prop: "msgId",
            minWidth: 120,
            overHidden: true,
            tip: true
          },
          {
            label: "消息类型",
            prop: "msgType",
            width: 100,
            slot: true
          },
          {
            label: "消息内容",
            prop: "content",
            minWidth: 200,
            slot: true
          },
          {
            label: "发送者",
            prop: "sender",
            width: 100,
            overHidden: true,
            tip: true
          },
          {
            label: "接收者",
            prop: "receiver",
            width: 100,
            overHidden: true,
            tip: true
          },
          {
            label: "任务数量",
            prop: "taskCount",
            width: 80,
            type: "number"
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
            type: "datetime",
            format: "yyyy-MM-dd HH:mm:ss",
            valueFormat: "yyyy-MM-dd HH:mm:ss"
          }
        ]
      }
    };
  },
  
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    
    dialogTitle() {
      return this.sessionData ? `会话消息 - ${this.sessionData.title || this.sessionData.sessionId}` : '会话消息';
    }
  },
  
  watch: {
    visible(newVal) {
      if (newVal && this.sessionData) {
        this.loadMessageList();
      }
    }
  },
  
  methods: {
    
    // 获取消息类型颜色
    getMsgTypeColor(type) {
      const typeMap = {
        'user': 'primary',
        'assistant': 'success',
        'system': 'warning',
        'error': 'danger'
      };
      return typeMap[type] || 'info';
    },
    
    // 获取消息类型文本
    getMsgTypeText(type) {
      const typeMap = {
        'user': '用户消息',
        'assistant': 'AI回复',
        'system': '系统消息',
        'error': '错误消息'
      };
      return typeMap[type] || type;
    },
    
    // 截断文本
    truncateText(text, maxLength) {
      if (!text) return '';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    },
    
    // 查看消息任务
    handleViewTasks(row) {
      console.log('handleViewTasks called with:', row);
      
      // 先关闭当前弹窗
      this.dialogVisible = false;
      
      // 跳转到任务页面，传递chatId参数
      const routeParams = {
        path: '/aiSession/tasks',
        query: {
          chatId: row.chatId,
          sessionId: this.sessionData.sessionId,
          sessionTitle: this.sessionData.title || this.sessionData.sessionId
        }
      };
      
      console.log('Navigating to:', routeParams);
      this.$router.push(routeParams);
    },
    
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.messageData = [];
      this.page = {
        size: 10,
        current: 1,
        total: 0
      };
    },
    
    // 当前页变化
    currentChange(currentPage) {
      this.page.current = currentPage;
      this.loadMessageList();
    },
    
    // 页大小变化
    sizeChange(pageSize) {
      this.page.size = pageSize;
      this.loadMessageList();
    },
    
    // 刷新
    refreshChange() {
      this.loadMessageList();
    },
    
    // 加载数据
    onLoad() {
      this.loadMessageList();
    },
    
    // 加载消息列表
    loadMessageList() {
      if (!this.sessionData || !this.sessionData.sessionId) {
        return;
      }
      
      this.loading = true;
      const requestData = {
        current: this.page.current,
        size: this.page.size,
        sessionId: this.sessionData.sessionId
      };
      
      getAiSessionMsgList(requestData).then(res => {
        if (res.data.code === 200 || res.data.code === 0) {
          const data = res.data.data;
          this.page.total = data.total;
          this.messageData = data.records || [];
          this.loading = false;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg || "获取消息列表失败");
        }
      }).catch(error => {
        this.loading = false;
        console.error("获取消息列表失败:", error);
        this.$message.error("获取消息列表失败，请重试");
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.session-message-dialog {
  z-index: 3000 !important;
  
  .session-info {
    background: #f8f9fa;
    padding: 15px;
    border-radius: 4px;
    margin-bottom: 20px;
    
    .info-item {
      margin-bottom: 8px;
      
      label {
        font-weight: 500;
        color: #606266;
        margin-right: 8px;
      }
      
      span {
        color: #303133;
      }
    }
  }
  
  .message-list {
    .message-content {
      line-height: 1.5;
      word-break: break-word;
    }
  }
  
  .dialog-footer {
    text-align: right;
  }
}

/* 确保弹窗遮罩层级正确 */
.el-dialog__wrapper {
  z-index: 3000 !important;
}

/* 确保弹窗内容层级正确 */
.el-dialog {
  z-index: 3001 !important;
}

/* 设置操作栏宽度 */
.session-message-dialog .avue-crud__menu {
  min-width: 100px !important;
  width: 100px !important;
}

/* 表格单元格文本溢出处理 */
.session-message-dialog .el-table .cell {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

/* 确保tooltip正常显示 */
.el-tooltip__popper {
  max-width: 400px;
  word-break: break-all;
  line-height: 1.5;
  z-index: 3002 !important;
}</style>
